import { Component, OnInit, ViewChild, inject } from '@angular/core';
import {
  NgbDate, NgbDateStruct, NgbDatepicker, NgbDatepickerConfig, NgbInputDatepicker,
} from '@ng-bootstrap/ng-bootstrap';

import { FieldBaseComponent } from '../base-component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-lib-ff-date-picker',
  styleUrls: ['./date-picker.component.scss'],
  templateUrl: './date-picker.component.html',
  imports: [NgbInputDatepicker, FormsModule, ReactiveFormsModule],
})
export class FormlyDatepickerComponent extends FieldBaseComponent implements OnInit {
  private readonly ngbDatepickerConfig = inject(NgbDatepickerConfig);

  @ViewChild(NgbDatepicker) public formFieldControl: NgbDatepicker;

  public minDate: NgbDateStruct;
  public maxDate: NgbDateStruct;

  public ngOnInit() {
    const date = new Date();
    this.minDate =
      this.getDate(this.props?.minDate ?? new Date(date.getFullYear() - 100, date.getMonth(), date.getDate()));
    this.maxDate =
      this.getDate(this.props?.maxDate ?? new Date(date.getFullYear() - 18, date.getMonth(), date.getDate()));

    this.ngbDatepickerConfig.minDate = this.minDate;
    this.ngbDatepickerConfig.maxDate = this.maxDate;
  }

  public isDateInvalid(date: NgbDate): boolean {
    return (this.minDate && date.before(this.minDate)) || (this.maxDate && date.after(this.maxDate));
  }

  private getDate(date: Date) {
    if (!date) {
      return null;
    }
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
    } as NgbDateStruct;
  }
}
